<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="currentUser" (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="isMobileMenuOpen" (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h1 class="page-title">รายละเอียดรายการสอบ</h1>
              <p class="page-subtitle">ข้อมูลการลงทะเบียนและสอบประเมินผล</p>
            </div>
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>กลับ
            </button>
          </div>
        </div>

        <!-- Success Alert -->
        @if (successMessage) {
        <ngb-alert type="success" [dismissible]="true" (closed)="successMessage = null" class="mb-3">
          <i class="bi bi-check-circle me-2"></i>{{ successMessage }}
        </ngb-alert>
        }

        <!-- Error Alert -->
        <ngb-alert *ngIf="error" type="danger" [dismissible]="true" (closed)="error = null" class="mb-3">
          <i class="bi bi-exclamation-triangle me-2"></i>{{ error }}
        </ngb-alert>

        <!-- Exam List Detail Content -->
        <div *ngIf="examDetail" class="detail-container">
          <!-- User Information Card -->
          <div class="card mb-4">
            <div class="card-header bg-primary text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-person-circle me-2"></i>ข้อมูลผู้สมัครสอบ
              </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">ชื่อ-สกุลผู้สมัคร:</label>
                    <div class="info-value">{{ getApplicantName() }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">เลขบัตรประชาชน:</label>
                    <div class="info-value font-monospace">{{ examDetail.user.cid }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">เบอร์โทร:</label>
                    <div class="info-value">{{ getApplicantPhone() }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">หน่วยงาน/สังกัด:</label>
                    <div class="info-value">{{ getApplicantOrganization() }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">อีเมล:</label>
                    <div class="info-value">{{ examDetail.user.email }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">สถานะบัญชี:</label>
                    <div class="info-value">
                      <span class="badge" [ngClass]="getActiveStatusBadgeClass(examDetail.user.isActive)">
                        {{ getActiveStatusText(examDetail.user.isActive) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Exam Information Card -->
          <div class="card mb-4 exam-card">
            <div class="card-header bg-gradient-blue text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-clipboard-check-fill me-2"></i>ข้อมูลการสอบ
              </h5>
              <p class="mb-0 mt-1" style="font-size: 0.9rem; opacity: 0.9;">
                <i class="bi bi-info-circle me-1"></i>รายละเอียดเกี่ยวกับการสอบประเมินผล
              </p>
            </div>
            <div class="card-body p-4">
              <!-- Exam Title Section -->
              <div class="exam-title-section mb-4">
                <div class="d-flex align-items-start">
                  <div class="exam-icon me-3">
                    <i class="bi bi-clipboard-check"></i>
                  </div>
                  <div class="flex-grow-1">
                    <label class="exam-label">ชื่อการสอบ</label>
                    <h4 class="exam-title mb-0">{{ examDetail.exam.examTitle }}</h4>
                  </div>
                </div>
              </div>

              <!-- Exam Description -->
              <div class="exam-description-section mb-4">
                <div class="d-flex align-items-start">
                  <div class="exam-icon me-3">
                    <i class="bi bi-file-text-fill"></i>
                  </div>
                  <div class="flex-grow-1">
                    <label class="exam-label">หมายเหตุ</label>
                    <p class="exam-description mb-0">{{ examDetail.exam.remarks || '-' }}</p>
                  </div>
                </div>
              </div>

              <!-- Exam Details Grid -->
              <div class="row g-3">
                <!-- Valuer Rank -->
                <div class="col-md-6">
                  <div class="exam-detail-item">
                    <div class="detail-icon bg-purple">
                      <i class="bi bi-star-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">ผู้ประเมินหลักประเภท</label>
                      <div class="detail-value">{{ examDetail.exam.valuerRank }}</div>
                    </div>
                  </div>
                </div>

                <!-- Exam Time -->
                <div class="col-md-6">
                  <div class="exam-detail-item">
                    <div class="detail-icon bg-blue">
                      <i class="bi bi-clock-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">เวลาสอบ</label>
                      <div class="detail-value">
                        <span class="badge bg-primary badge-lg">
                          <i class="bi bi-clock me-1"></i>
                          {{ examDetail.exam.examTime }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Exam Location -->
                <div class="col-md-6">
                  <div class="exam-detail-item">
                    <div class="detail-icon bg-teal">
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">สถานที่สอบ</label>
                      <div class="detail-value">
                        <span class="badge bg-info badge-lg">
                          <i class="bi bi-pin-map-fill me-1"></i>
                          {{ examDetail.exam.examLocation }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Exam Date -->
                <div class="col-md-6">
                  <div class="exam-detail-item">
                    <div class="detail-icon bg-orange">
                      <i class="bi bi-calendar-event-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">วันสอบ</label>
                      <div class="detail-value">
                        <span class="badge badge-lg bg-warning">
                          <i class="bi bi-calendar-check me-1"></i>
                          {{ formatDate(examDetail.exam.examDate) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Exam Fee -->
                <div class="col-md-6">
                  <div class="exam-detail-item highlight">
                    <div class="detail-icon bg-green">
                      <i class="bi bi-cash-coin"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">ค่าสอบ</label>
                      <div class="detail-value price-value">
                        <i class="bi bi-currency-dollar me-1"></i>
                        {{ formatPrice(examDetail.exam.examFee) }} บาท
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Registration Deadline -->
                <div class="col-md-6">
                  <div class="exam-detail-item">
                    <div class="detail-icon bg-indigo">
                      <i class="bi bi-calendar-x-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">วันหมดเขตรับสมัคร</label>
                      <div class="detail-value">
                        <span class="badge badge-lg bg-danger">
                          <i class="bi bi-exclamation-triangle me-1"></i>
                          {{ formatDate(examDetail.exam.registrationDeadline) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Status Information Card -->
          <div class="card mb-4 status-card">
            <div class="card-header bg-gradient-cyan text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-sliders me-2"></i>สถานะและการยืนยัน
              </h5>
              <p class="mb-0 mt-1" style="font-size: 0.9rem; opacity: 0.9;">
                <i class="bi bi-info-circle me-1"></i>คุณสามารถเปลี่ยนสถานะได้โดยเลือกจากรายการด้านล่าง
              </p>
            </div>
            <div class="card-body p-4">
              <div class="row g-4">

                <!-- Payment Status (แสดงอย่างเดียว) -->
                <div class="col-md-6">
                  <div class="status-item">
                    <label class="status-label">
                      <i class="bi bi-credit-card me-2"></i>สถานะการชำระเงิน:
                    </label>
                    <div class="status-control">
                      <!-- แสดงอย่างเดียว: การปรับสถานะทำที่เมนู "ตรวจสอบการชำระเงิน" -->
                      <div class="status-badge-preview">
                        <span class="badge badge-lg"
                          [ngClass]="getExamPaymentStatusBadgeClass(examDetail.examListPaymentStatus.name)">
                          <i class="bi bi-circle-fill me-2" style="font-size: 0.5rem;"></i>
                          {{ examDetail.examListPaymentStatus.name }}
                        </span>
                      </div>

                      <!-- Payment Slip Preview -->
                      <div *ngIf="examDetail.paymentSlip" class="mt-3">
                        <label class="d-block text-muted mb-1" style="font-size: 0.85rem;">
                          <i class="bi bi-image me-1"></i>สลิปการชำระเงิน
                        </label>
                        <div class="position-relative d-inline-block" style="cursor:pointer;"
                          (click)="slipModalUrl = examDetail.paymentSlip">
                          <img [src]="examDetail.paymentSlip" alt="Payment Slip"
                            style="max-width:160px; max-height:160px; border-radius:8px; border:2px solid #dee2e6; object-fit:cover;">
                          <div
                            class="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                            style="background:rgba(0,0,0,0.4); border-radius:8px; opacity:0; transition:opacity 0.2s;"
                            onmouseenter="this.style.opacity=1" onmouseleave="this.style.opacity=0">
                            <i class="bi bi-zoom-in text-white" style="font-size:1.5rem;"></i>
                            <small class="text-white mt-1">คลิกเพื่อดูขนาดเต็ม</small>
                          </div>
                        </div>
                        <div class="mt-2 d-flex flex-wrap gap-2">
                          <a [href]="examDetail.paymentSlip" target="_blank" class="btn btn-sm btn-outline-primary">
                            <i class="bi bi-box-arrow-up-right me-1"></i>เปิดรูปในแท็บใหม่
                          </a>
                        </div>
                      </div>

                      <!-- Transfer DateTime Display -->
                      <div *ngIf="examDetail.transferDateTime" class="mt-3 transfer-datetime-display">
                        <label class="d-block text-muted mb-2" style="font-size: 0.85rem;">
                          <i class="bi bi-clock-history me-1"></i>วันเวลาการโอนเงิน
                        </label>
                        <div class="transfer-datetime-box">
                          <div class="datetime-icon">
                            <i class="bi bi-calendar-check-fill"></i>
                          </div>
                          <div class="datetime-content">
                            <span class="datetime-text">{{ examDetail.transferDateTime }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Confirmation Status (Editable) -->
                <div class="col-md-6">
                  <div class="status-item">
                    <label class="status-label">
                      <i class="bi bi-shield-check me-2"></i>สถานะการยืนยัน:
                    </label>
                    <div class="status-control">
                      <select class="form-select form-select-lg status-select" [(ngModel)]="examDetail.examListStatusId"
                        (change)="updateConfirmationStatus(examDetail.examListStatusId)">
                        <option *ngFor="let status of confirmationStatusOptions" [value]="status.id">
                          {{ status.name }}
                        </option>
                      </select>
                      <div class="status-badge-preview mt-2">
                        <span class="badge badge-lg"
                          [ngClass]="getConfirmationStatusBadgeClass(examDetail.examListStatus?.name || getConfirmationStatusName(examDetail.examListStatusId))">
                          <i class="bi bi-circle-fill me-2" style="font-size: 0.5rem;"></i>
                          {{ examDetail.examListStatus?.name || getConfirmationStatusName(examDetail.examListStatusId)
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Completion Status (Editable) -->
                <div class="col-md-6">
                  <div class="status-item">
                    <label class="status-label">
                      <i class="bi bi-trophy me-2"></i>สถานะการสอบจบ:
                    </label>
                    <div class="status-control">
                      <select class="form-select form-select-lg status-select" [(ngModel)]="examDetail.examResult"
                        (change)="updateCompletionStatus(examDetail.examResult ?? null)">
                        <option *ngFor="let option of completionOptions" [ngValue]="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                      <div class="status-badge-preview mt-2">
                        <span class="badge badge-lg" [ngClass]="getCompletionBadgeClass(examDetail.examResult)">
                          <i class="bi bi-circle-fill me-2" style="font-size: 0.5rem;"></i>
                          {{ getCompletionText(examDetail.examResult) }}
                        </span>
                      </div>
                      <small class="text-muted d-block mt-2">
                        <i class="bi bi-info-circle me-1"></i>
                        ผู้สมัครจะเห็นผลการสอบเฉพาะเมื่อเลือก "ผ่าน" เท่านั้น
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Attached File Preview (Full Width) -->
                <div class="col-12" *ngIf="examDetail.attachFile">
                  <div class="status-item">
                    <label class="status-label">
                      <i class="bi bi-paperclip me-2"></i>หลักฐานการสมัครสอบ:
                    </label>
                    <div class="attach-file-preview mt-3">
                      <!-- Image Preview -->
                      <div *ngIf="isImageFile(examDetail.attachFile)" class="image-preview-card">
                        <div class="image-container" (click)="slipModalUrl = examDetail.attachFile">
                          <img [src]="examDetail.attachFile" alt="Exam Evidence" class="preview-image">
                          <div class="image-overlay">
                            <i class="bi bi-zoom-in"></i>
                            <span>คลิกเพื่อดูขนาดเต็ม</span>
                          </div>
                        </div>
                        <div class="file-actions mt-3">
                          <a [href]="examDetail.attachFile" target="_blank" class="btn btn-outline-primary btn-sm">
                            <i class="bi bi-box-arrow-up-right me-1"></i>เปิดในแท็บใหม่
                          </a>
                          <a [href]="examDetail.attachFile" download class="btn btn-outline-success btn-sm">
                            <i class="bi bi-download me-1"></i>ดาวน์โหลด
                          </a>
                        </div>
                      </div>

                      <!-- PDF Preview -->
                      <div *ngIf="isPdfFile(examDetail.attachFile)" class="pdf-preview-card">
                        <div class="pdf-icon-container">
                          <i class="bi bi-file-earmark-pdf-fill"></i>
                          <span class="pdf-label">ไฟล์ PDF</span>
                        </div>
                        <div class="file-actions mt-3">
                          <a [href]="examDetail.attachFile" target="_blank" class="btn btn-primary btn-sm">
                            <i class="bi bi-eye me-1"></i>เปิดดู PDF
                          </a>
                          <a [href]="examDetail.attachFile" download class="btn btn-outline-success btn-sm">
                            <i class="bi bi-download me-1"></i>ดาวน์โหลด
                          </a>
                        </div>
                      </div>

                      <!-- Other File Types -->
                      <div *ngIf="!isImageFile(examDetail.attachFile) && !isPdfFile(examDetail.attachFile)" class="file-preview-card">
                        <div class="file-icon-container">
                          <i class="bi bi-file-earmark"></i>
                          <span class="file-label">ไฟล์แนบ</span>
                        </div>
                        <div class="file-actions mt-3">
                          <a [href]="examDetail.attachFile" target="_blank" class="btn btn-outline-primary btn-sm">
                            <i class="bi bi-box-arrow-up-right me-1"></i>เปิดไฟล์
                          </a>
                          <a [href]="examDetail.attachFile" download class="btn btn-outline-success btn-sm">
                            <i class="bi bi-download me-1"></i>ดาวน์โหลด
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Status Update Info -->
              <div class="alert alert-info mt-4 mb-0" role="alert">
                <i class="bi bi-lightbulb me-2"></i>
                <strong>คำแนะนำ:</strong> การเปลี่ยนสถานะจะมีผลทันทีและบันทึกลงในระบบอัตโนมัติ
              </div>
            </div>
          </div>

          <!-- Registration Information -->
          <div class="card shadow-sm mb-4 registration-card">
            <div class="card-header bg-gradient-purple text-white">
              <h5 class="mb-0">
                <i class="bi bi-card-checklist me-2"></i>ข้อมูลการลงทะเบียน
              </h5>
            </div>
            <div class="card-body p-4">
              <div class="row g-4">
                <!-- Registration Date -->
                <div class="col-md-6">
                  <div class="registration-item">
                    <div class="registration-icon bg-gradient-primary">
                      <i class="bi bi-calendar-plus"></i>
                    </div>
                    <div class="registration-content">
                      <label class="registration-label">วันที่ลงทะเบียน</label>
                      <div class="registration-value">
                        <i class="bi bi-clock me-2 text-primary"></i>
                        {{ formatDate(examDetail.createdAt) }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Created Date -->
                <div class="col-md-6">
                  <div class="registration-item">
                    <div class="registration-icon bg-gradient-info">
                      <i class="bi bi-file-earmark-plus"></i>
                    </div>
                    <div class="registration-content">
                      <label class="registration-label">วันที่สร้างข้อมูล</label>
                      <div class="registration-value">
                        <i class="bi bi-database me-2 text-info"></i>
                        {{ formatDate(examDetail.createdAt) }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Updated Date -->
                <div class="col-md-6">
                  <div class="registration-item">
                    <div class="registration-icon bg-gradient-warning">
                      <i class="bi bi-arrow-repeat"></i>
                    </div>
                    <div class="registration-content">
                      <label class="registration-label">วันที่อัปเดตข้อมูล</label>
                      <div class="registration-value">
                        <i class="bi bi-pencil-square me-2 text-warning"></i>
                        {{ formatDate(examDetail.updatedAt) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 justify-content-end">
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>กลับ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Payment Slip Image Modal -->
<div *ngIf="slipModalUrl"
  style="position:fixed; inset:0; z-index:1080; display:flex; align-items:center; justify-content:center; background:rgba(0,0,0,0.75);"
  (click)="slipModalUrl = null">
  <button type="button"
    style="position:absolute; top:1.25rem; right:1.25rem; background:none; border:none; color:#fff; font-size:2rem; line-height:1; cursor:pointer;"
    (click)="slipModalUrl = null">
    <i class="bi bi-x-lg"></i>
  </button>
  <img [src]="slipModalUrl" alt="Payment Slip Full Size"
    style="max-width:90vw; max-height:90vh; border-radius:8px; box-shadow:0 8px 40px rgba(0,0,0,0.5);"
    (click)="$event.stopPropagation()">
</div>